import { useState, useEffect, useRef } from "react";

export const useDebouncedFilterWithRef = (data, filterRef, filterFn, mapFn,debounceDelay = 300) => {
    const [filteredData, setFilteredData] = useState([]);
    const [isFiltering, setIsFiltering] = useState(false);

    const debounceTimeout = useRef();

    // refs para manter valores sempre atualizados sem recriar o handler
    const dataRef = useRef(data);
    const filterFnRef = useRef(filterFn);
    const mapFnRef = useRef(mapFn);
    const debounceDelayRef = useRef(debounceDelay);

    useEffect(() => { dataRef.current = data; }, [data]);
    useEffect(() => { filterFnRef.current = filterFn; }, [filterFn]);
    useEffect(() => { mapFnRef.current = mapFn; }, [mapFn]);
    useEffect(() => { debounceDelayRef.current = debounceDelay; }, [debounceDelay]);

    useEffect(() => {
        const inputElem = filterRef.current;
        if (inputElem) inputElem.addEventListener("input", onChange);

        return () => {
            if (inputElem) inputElem.removeEventListener("input", onChange);
            clearTimeout(debounceTimeout.current);
        };
    }, []); 

    const handleFilter = () => {
        const value = filterRef.current?.value || "";
        if (!value) {
            setFilteredData([]);
            setIsFiltering(false);
            return;
        }

        const filtered = filterFnRef.current(dataRef.current, value);
        const mapped = mapFnRef.current ? mapFnRef.current(filtered) : filtered;

        setFilteredData(mapped);
        setIsFiltering(false);
    };

    const onChange = () => {
        setIsFiltering(true);
        clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(handleFilter, debounceDelayRef.current);
    };


  return { filteredData, isFiltering, setFilteredData };
};
